import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_new_target",
  ref: "newTargetModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header bg-primary pb-0 border-0 justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-sm btn-icon btn-active-color-primary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-13 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-3" }, "Set First Target"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-5" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "fw-bolder link-primary"
    }, "Project Guidelines"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_7 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Target Title"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a target name for future usage and reference"
  })
], -1)
const _hoisted_9 = { class: "row g-9 mb-8" }
const _hoisted_10 = { class: "col-md-6 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Assign", -1)
const _hoisted_12 = { class: "col-md-6 fv-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold mb-2" }, "Due Date", -1)
const _hoisted_14 = { class: "position-relative align-items-center" }
const _hoisted_15 = { class: "symbol symbol-20px me-4 position-absolute ms-4" }
const _hoisted_16 = { class: "symbol-label bg-secondary" }
const _hoisted_17 = { class: "svg-icon" }
const _hoisted_18 = { class: "d-flex flex-column mb-8" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Target Details", -1)
const _hoisted_20 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tags"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a target priorty"
  })
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Adding Users by Team Members"),
    /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-gray-400" }, " If you need more info, please check budget planning ")
  ]),
  /*#__PURE__*/_createElementVNode("label", { class: "form-check form-switch form-check-custom form-check-solid" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input",
      type: "checkbox",
      value: "1",
      checked: "checked"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-400" }, " Allowed ")
  ])
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "mb-15 fv-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold me-5" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "fs-6" }, "Notifications"),
      /*#__PURE__*/_createElementVNode("div", { class: "fs-7 text-gray-400" }, " Allow Notifications by Phone or Email ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-custom form-check-solid me-10" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input h-20px w-20px",
          type: "checkbox",
          name: "communication[]",
          value: "email",
          checked: "checked"
        }),
        /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Email ")
      ]),
      /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-custom form-check-solid" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input h-20px w-20px",
          type: "checkbox",
          name: "communication[]",
          value: "phone"
        }),
        /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Phone ")
      ])
    ])
  ])
], -1)
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_new_target_cancel",
  class: "btn btn-white me-3"
}, " Cancel ", -1)
const _hoisted_26 = ["data-kt-indicator"]
const _hoisted_27 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_28 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_29 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            id: "kt_modal_new_target_form",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.targetData,
            rules: _ctx.rules,
            ref: "formRef",
            class: "form"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_el_form_item, { prop: "targetTitle" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.targetData.targetTitle,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetData.targetTitle) = $event)),
                      placeholder: "Enter Target Title",
                      name: "targetTitle"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_el_form_item, { prop: "assign" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.targetData.assign,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.targetData.assign) = $event)),
                        placeholder: "Select a Team Member",
                        name: "assign",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, { value: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Select user...")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Karina Clark",
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Karina Clark")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Robert Doe",
                            value: "2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Robert Doe")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Niel Owen",
                            value: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Niel Owen")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Olivia Wild",
                            value: "4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Olivia Wild")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Sean Bean",
                            value: "5"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Sean Bean")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen025.svg" })
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, { prop: "dueDate" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.targetData.dueDate,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetData.dueDate) = $event)),
                          placeholder: "Select a date",
                          name: "dueDate"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_el_form_item, { prop: "targetDetails" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.targetData.targetDetails,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetData.targetDetails) = $event)),
                      type: "textarea",
                      rows: "3",
                      name: "targetDetails",
                      placeholder: "Type Target Details"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_el_form_item, { prop: "tags" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.targetData.tags,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.targetData.tags) = $event)),
                      multiple: "",
                      filterable: "",
                      "allow-create": "",
                      "default-first-option": "",
                      placeholder: "Choose tags for your target"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Important",
                          value: "important"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Urgent",
                          value: "urgent"
                        }),
                        _createVNode(_component_el_option, {
                          label: "high",
                          value: "high"
                        }),
                        _createVNode(_component_el_option, {
                          label: "low",
                          value: "low"
                        }),
                        _createVNode(_component_el_option, {
                          label: "medium",
                          value: "medium"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_30
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_26)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ], 512))
}